import React, { useState, useEffect } from 'react';
import DivTag from '../../Components/DivComponent/DivTag';
import Button from '../../Components/ButtonComponent/Button';
import InputWithLabel from '../../Components/InputComponent/InputWithLabel';
import HeadingTag from '../../Components/HeadingComponent/HeadingTag';
import SelectWithLabelOption from '../../Components/SelectComponent/SelectWithLabelOption';
import ReportHeading from '../../Components/ReportHeadings/ReportHeadings';
import Option from '../../Components/OptionComponent/Option';
import InputReadonly from '../../Components/InputComponent/InputReadonly';
import FormTag from '../../Components/FormComponent/FormTag';
import { motion } from 'framer-motion';
import { DeleteDocumentService, DocumentPreviewService, GetUploadedByIdService, GetUploadedDocumentIdService, GetUserDataByIdService, UploadedDocumentService } from '../../../services/apiService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import PopMenu from '../../../components/Dialog/PopMenu';
import { ToastContainer } from "react-toastify";
import Seo from '../../../components/SeoComponent/Seo';
const ApiUserKyc = () => {


    const [searchText, setSearchText] = useState('');
    const [userData, setUserData] = useState();
    const [companyData, setCompanyData] = useState();
    const [documentsType, setDocumentType] = useState([]);
    const [isDocUploading, setIsDocUploading] = useState(false);
    const [uploadedDocument, setUploadedDocument] = useState([]);
    const [selectedDocumentId, setSelectedDocumentId] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [selectFileName, setSelectedFileName] = useState('');
    const [previewFile, setPreviewFile] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const [tableData, setTableData] = useState([
        {
            SrNo: 1,
            Document: '1',
            DocumentPreview: '',
            Status: 'success',
            Action: ''
        }
    ]);
    const handleDelete = (index) => {
        const updatedTableData = [...tableData];
        updatedTableData.splice(index, 1);
        setTableData(updatedTableData);
    };
    async function DocumentTypeLists() {
        try {
            const response = await GetUploadedByIdService();

            setDocumentType(response.data)
        } catch (error) {
            return
        }
    }
    async function UplodedDocumentLists() {
        try {
            const response = await GetUploadedDocumentIdService({ userId: searchText.toUpperCase() });
            console.log(response)
            setUploadedDocument(response.data)
        } catch (error) {
            return
        }
    }
    async function getUserDetailsOnSearch() {
        try {
            const response = await GetUserDataByIdService({ userId: searchText });

            if (response.success === true) {

                setCompanyData(response.company);
                setUserData(response.user)
                await DocumentTypeLists();
                await UplodedDocumentLists();
            }

        } catch (error) {
            return
        }
    }
    async function handleUploadDocument() {
        try {
            setIsDocUploading(true)
            if (selectedDocumentId === '') {
                setIsDocUploading(false)
                return showErrorToast('Document type is required')
            }
            if (selectedFile === null) {
                setIsDocUploading(false)
                return showErrorToast("Please select new file")
            }
            const formData = new FormData();
            formData.append('userid', searchText);
            formData.append('docid', selectedDocumentId);
            formData.append('file', selectedFile)

            const resp = await UploadedDocumentService({
                userId: formData.get('userid'),
                docid: formData.get('docid'),
                file: formData.get('file')

            });

            if (resp.status === "success") {
                setIsDocUploading(false)
                setSelectedFile(null);
                await UplodedDocumentLists();
                showSuccessToast('Docment upload success ');
            }

        } catch (error) {
            setIsDocUploading(true)
            return error
        }
    }
    async function handlePreviewDoc(filename) {
        try {

            setIsPreviewOpen(true);
            setSelectedFileName(filename)

            const response = await DocumentPreviewService(selectFileName);

            setPreviewFile(response.dataUri);
        } catch (error) {

        }

    }

    async function handleDeleteDocument(docId) {
        try {
            setIsLoading(true);
            const response = await DeleteDocumentService({ userId: searchText, docid: docId });
            if (response.status === 403) {
                setIsLoading(false);
                showErrorToast(response.data.message);
                return
            }
            if (response.status.code === 200) {
                await UplodedDocumentLists();
                setIsLoading(false);
                showSuccessToast(response.message)
            }

        } catch (error) {
            setIsLoading(false);
            showErrorToast("failed to delete document ");
            return
        }
    }
  
    useEffect(() => {
        setTimeout(() => {
            getUserDetailsOnSearch();
        }, 1000)

    }, [searchText])

    return (

        <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
        >
            <Seo />

            <DivTag id="" className=" border-2 border-solid border-blue-800 rounded-xl border-t-0 mt-8 bg-white px-5">

                <ReportHeading name="Upload KYC" />
               
                <DivTag className="border border-solid border-blue-800 rounded-md 
                flex justify-center items-center mt-3">
                    <PopMenu visible={isPreviewOpen} onClose={() => setIsPreviewOpen(false)} className={'h-1/2 p-5'} title={"Document Preview"}>
                        <img src={previewFile} className='h-full w-full' alt="document image" />
                    </PopMenu>
                    <FormTag
                        method=""
                        autoComplete="off">

                        <DivTag className="flex flex-wrap p-2">
                            <div className='flex flex-col items-start -mt-2'>
                                <label htmlFor="" className='text-slate-600 font-bold'>Search User</label>
                                <input type='text' onChange={(e) => setSearchText(e.target.value)} value={searchText.toUpperCase()}
                                    placeholder='Search..'
                                    className='border shadow-md h-9 rounded-md text-black outline-none px-2 border-blue-500'
                                />
                            </div>

                            <InputReadonly
                                DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-black"
                                label="Company Name"
                                type="text"
                                name="api_user_name"
                                value={companyData?.company_name}
                                id="api_user_name"
                                readOnly="readOnly"

                            />

                            <InputReadonly
                                DivclassName="w-full md:w-1/5 px-2 md:mb-0 text-black"
                                label="Api User Name"
                                type="text"
                                name="api_user_name"
                                value={userData?.name}
                                id="api_user_name"
                                readOnly="readOnly"

                            />


                            <InputReadonly
                                DivclassName="w-full md:w-1/4 px-2 md:mb-0"
                                label="Authorized Signatiory Name"
                                type="text"
                                name="auth_sign_name"
                                id="auth_sign_name"
                                readOnly="readOnly"
                                value={userData?.name}
                            />

                            <InputReadonly
                                DivclassName="w-full md:w-1/4 md:mb-0"
                                label="Aadhar No.(AuthorizedSignatiory)"
                                type="text"
                                name="aadhar_no"
                                id="aadhar_no"
                                readOnly="readOnly"
                                value={userData?.aadhar_number}
                            />

                            <InputReadonly
                                DivclassName="w-full md:w-1/4 mt-3 px-2 md:mb-0"
                                label="Pan No.(Authorized Signatiory)"
                                type="text"
                                name="pan_no"
                                id="pan_no"
                                readOnly="readOnly"
                                value={userData?.pan_number}
                            />

                            <InputReadonly
                                DivclassName="w-full md:w-1/3 mt-3 px-3 md:mb-0"
                                label="Company Pan"
                                type="text"
                                name="company_pan"
                                id="company_pan"
                                readOnly="readOnly"
                                value={companyData?.company_pan}
                            />

                            <InputReadonly
                                DivclassName="w-full md:w-1/3 mt-3 md:mb-0"
                                label="Address"
                                type="text"
                                name="address"
                                id="address"
                                readOnly="readOnly"
                                value={userData?.landmark_address}
                            />

                            <SelectWithLabelOption
                                DivclassName="w-full md:w-1/3 mt-3 px-4 md:mb-0"
                                label="Choose Document"
                                id="choose_document"
                                name="choose_document"
                                onChange={(e) => setSelectedDocumentId(e.target.value)}
                            >
                                <Option value="" selected disabled>Choose Document</Option>
                                {
                                    documentsType.length > 0 ?
                                        documentsType.map((val, index) => (
                                            <option value={val.id} key={index}>{val.name}</option>
                                        ))
                                        : ""

                                }
                            </SelectWithLabelOption>

                            <InputWithLabel
                                DivclassName="w-full md:w-1/3 mt-3 px-3 md:mb-0"
                                label="File Upload"
                                type="file"
                                name="file_upload"
                                id="file_upload"
                                error='Max Size : 2 MB  is allowed'
                                
                                onChange={(e) => setSelectedFile(e.target.files[0])}
                            />

                        </DivTag>

                        <DivTag className="flex justify-center">
                            <Button
                                type="button"
                                className={isDocUploading ? "hidden" : "text-center text-white bg-blue-700 shadow-lg bg-gradient-to-r from-blue-900 via-teal-400 to-purple-900 font-semibold p-0 rounded-md px-2 py-1 text-lg hover:bg-red-300"}
                                id="submitApiUserKyc"
                                name="submitApiUserKyc"
                                onClick={handleUploadDocument}

                            >Submit
                            </Button>
                        </DivTag>
                    </FormTag>

                </DivTag>


                <div className="flex justify-center mb-5 overflow-x-auto">
                    <table className="min-w-4/5 table-auto border-collapse">
                        <thead className="text-md bg-gray-100">
                            <tr className='bg-blue-600 text-white'>
                                <th className="p-1 border-r text-center">S No.</th>
                                <th className="p-1 border-r text-center">Document</th>
                                <th className="p-1 border-r text-center">Document Preview</th>
                                <th className="p-1 border-r text-center">Status</th>
                                <th className="p-1 border-r text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                uploadedDocument.length > 0 ?
                                    uploadedDocument.map((item, index) => (
                                        <tr key={index} className="border-t">
                                            <td className="p-1 border text-center">{index + 1}</td>
                                            <td className="p-1 border text-center">{item?.remarks}</td>
                                            <td className="p-1 border text-center">
                                                <button
                                                    type="button"
                                                    className="text-white bg-green-600 rounded-md text-sm px-1 py-0"
                                                    onClick={() => handlePreviewDoc(item.document_path)}
                                                >
                                                    Preview
                                                </button>
                                            </td>
                                            <td
  className={`p-1 text-center ${
    item?.status === 'pending' ? 'bg-yellow-600 text-white rounded-full' :
    item?.status === 'approved' ? 'text-white bg-green-500 rounded-full' : ''
  }`}
>
  {item?.status}
</td>

                                            <td className="p-1 text-center">
                                                <button
                                                    type="button"
                                                    className="text-white bg-red-500 rounded-sm px-1 py-0"

                                                    onClick={() => handleDeleteDocument(item.document.id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td colSpan="5" className="px-4 py-2 text-center text-black text-xl">Data Not Found</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <ToastContainer />
            </DivTag>
        </motion.div>

    );

};

export default ApiUserKyc;